// extracted by mini-css-extract-plugin
module.exports = {"cookiesWrapper":"CookiesWrapper_cookiesWrapper__935Oq","middle":"CookiesWrapper_middle__pIOhA"};